import { Box, Paper, PaperProps } from '@mui/material';
import { forwardRef } from 'react';

export type SurfaceProps = Omit<PaperProps, 'elevation'> & {
  withShadow?: boolean;
  withBorder?: boolean;
};

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  ({ children, sx, withShadow = true, withBorder = true, ...props }, ref) => {
    return (
      <Paper
        ref={ref}
        elevation={withShadow ? 1 : 0}
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 1,
          border: withBorder ? 1 : 0,
          borderColor: 'divider',
          ...sx,
        }}
        {...props}
      >
        {children}
      </Paper>
    );
  }
);

Surface.displayName = 'Surface';
